import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../api";
import { LogEvent, PlainDetails, Session } from "../../types/admin";

export type AdminUserViewState = {
    loaded: boolean
    error: string | null
    user_id: string | null
    first_name: string
    last_name: string
    username: string
    email: string
    is_active: boolean
    is_staff: boolean
    is_superuser: boolean
    teams: PlainDetails[]
    date_joined: string
    last_seen: string
    sessions: Session[]
    events: LogEvent[]
}

const initialState: AdminUserViewState = {
    loaded: false,
    error: null,
    user_id: null,
    first_name: '',
    last_name: '',
    username: '',
    email: '',
    is_active: false,
    is_staff: false,
    is_superuser: false,
    date_joined: '',
    last_seen: '',
    teams: [],
    sessions: [],
    events: []
}

export const getUser = createAsyncThunk(
    'adminUserView/getUser',
    async (user_id: string, thunkAPI) => {
        try {
            return await api.get(`/API/admin/users/${user_id}/`);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const slice = createSlice({
    name: 'adminUserView',
    initialState,
    reducers: {
        updateUser: (state, action: PayloadAction<AdminUserViewState>) => {
            Object.assign(state, action.payload);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUser.pending, (state) => {
                state.loaded = false;
                state.error = null;
            })
            .addCase(getUser.fulfilled, (state, action) => {
                state.loaded = true;
                state.error = null;
                Object.assign(state, action.payload as AdminUserViewState);
            })
            .addCase(getUser.rejected, (state, action) => {
                state.loaded = true;
                if (typeof action.payload === 'string') {
                    state.error = action.payload as string;
                } else if (typeof action.error?.message === 'string') {
                    state.error = action.error.message;
                }
            })
    }
});

export const { updateUser } = slice.actions;
export default slice.reducer;